export const ISSUER_OKTA = process.env.REACT_APP_ISSUER_OKTA;
export const CLIENT_ID_OKTA = process.env.REACT_APP_CLIENT_ID_OKTA;
export const URL_SURVEY_API = process.env.REACT_APP_URL_SURVEY_API;
export const REACT_APP_URL_SURVEY_API_EXT = process.env.REACT_APP_URL_SURVEY_API_EXT;
export const URL_SUPPLIER_API = process.env.REACT_APP_URL_SUPPLIER_API;
export const SCOPES_SCBM = process.env.REACT_APP_SCOPES_SCBM
export const URL_APP = process.env.REACT_APP_URL_APP

export const SAM_URL = process.env.REACT_APP_SAM_URL
export const CONTACTUS_URL = process.env.REACT_APP_CONTACTUS_URL

export const MUI_X_LICENSE_PRO = process.env.REACT_APP_MUI_X_LICENSE_PRO

export const URL_INTEGRATION_API = process.env.REACT_APP_URL_INTEGRATION_API

export const COO_DISCLAIMER_URL = process.env.REACT_APP_COO_DISCLAIMER_URL

export const URL_SUBTIER_API = process.env.REACT_APP_URL_SUBTIER_API

export const COC_SHOW_INTEGRATION_SECTION = process.env.REACT_APP_COC_SHOW_INTEGRATION_SECTION

export const CURRENT_ENV = process.env.REACT_APP_CURRENT_ENV